import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Layout.scss';

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white text-gray-900">
    <Header />
    <div className="h-4" /> {/* Espacio entre header y main */}
    <main className="flex-1 container mx-auto px-4 py-8">
      {children}
    </main>
    <Footer />
  </div>
);

export default Layout;
